import {inject, Injectable} from '@angular/core';
import {
  BUTTON_COLOR,
  BUTTON_SIZE,
  BUTTON_TYPE,
} from '@discocil/fv-components';
import {TranslateService} from '@ngx-translate/core';
import {first, Observable, Subject} from 'rxjs';
import {ConfirmConfig} from '../../domain/interfaces/confirm-config.interface';
import {ConfirmationPort} from '../../domain/ports/confirmation.port';
import {GlobalConfirmService} from '../../services/global-confirm/global-confirm.service';

@Injectable({providedIn: 'root'})
export class ConfirmationService implements ConfirmationPort {
  private readonly globalConfirmService = inject(GlobalConfirmService);
  private readonly translateService = inject(TranslateService);

  confirm(config: ConfirmConfig): Observable<boolean> {
    return this.openConfirmDialog(config);
  }

  private openConfirmDialog(config: ConfirmConfig): Observable<boolean> {
    const result$ = new Subject<boolean>();

    this.globalConfirmService.open({
      message: this.translateService.instant(
        config.titleKey.key,
        config.titleKey.params
      ),
      hideCloseIcon: true,
      onClosed: () => {
        result$.next(false);
        result$.complete();
      },
      buttons: [
        {
          text: this.translateService.instant(config.confirmKey),
          color: config.confirmButtonColor ?? BUTTON_COLOR.primary,
          size: BUTTON_SIZE.full,
          type: BUTTON_TYPE.filled,
          handler: (): void => {
            this.globalConfirmService.close();
            result$.next(true);
            result$.complete();
          },
        },
        {
          text: this.translateService.instant('global.cancel'),
          color: BUTTON_COLOR.transparent,
          size: BUTTON_SIZE.full,
          type: BUTTON_TYPE.filled,
          preventAutoClose: true,
          handler: (): void => this.globalConfirmService.close(),
        },
      ],
      ...(config.subtitleKey && {
        submessage: this.translateService.instant(
          config.subtitleKey.key,
          config.subtitleKey.params
        ),
      }),
    });

    return result$.pipe(first());
  }
}
